const supplierLayout = {
  quotation: "询价单",
  pendingQuotation: "待报价",
  resolveQuotation: "已报价",
  other: "其他",
  purchaseOrder: "订单",

  login: "登录",
  loginTitle: "登录WMS",
  acntNotExist: "账号不存在,请检查",
  acntNotAvailable: "账号已存在或被禁用",
  loginFail: "登录失败",
  updatePwd: "修改密码",
  pwd: "密码",
  inputPwd: "请输入密码",
  inputAct: "请输入账户",
  inputPwdSec: "请再次输入密码",
  confirmPwd: "确认密码",
  logOut: "退出登录",
  logOutTipTitle: "确定退出登录吗？",
  logOutTipContent: "确定退出后将返回登录页面。",

  confirmTip: "确定要拒绝此次问询报价吗？",
  confirmTip2: "报价后，采购商将收到你的报价，并可以接受或拒绝你的报价",
  pwdError: "密码修改失败",
  editPwd: "修改密码",
  searchByKeyword: "输入关键字搜索",
  accountErr:"账号或密码错误",
  deliveryNotice:'送货通知',
  business:'商务',
  reconciliation:'对账',
  contract:'合同管理',
  quotations:'报价',
  proQuotations:'商品报价',
  myQuotations:'我的报价',
};

export default supplierLayout;
